import { BaseModel } from './common/base-model';
import * as moment from 'moment';
import { isDevMode } from '@angular/core';

export interface SurveyInterface {
    classification_id: number;
    created_at: Date;
    deleted_at: Date;
    id: number;
    is_active: boolean;
    is_test: boolean;
    name: string;
    provider: string;
    provider_config: Object;
    provider_meta: Object;
    updated_at: Date;
    version: string;
}

export class SurveyModel extends BaseModel {
    attributes: SurveyInterface;
    id: string;
    
    constructor(data = null) {
        super(data);

        if (!data) {
            return;
        }

        if (this.get('deleted_at')) {
            this.set('deleted_at', moment(this.get('deleted_at')));
        }
    }

    safeToTakeSurveyInThisEnv() {
        //live surveys cannot be taken from dev environments
        return this.get('is_test') || !isDevMode(); 
    }
}


// WEBPACK FOOTER //
// ./src/app/models/survey.model.ts